import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from "@material-ui/core/CircularProgress";
import { SalesAgenciesList } from './SalesAgenciesList/SalesAgenciesList';
import { SalesAgenciesTree } from './SalesAgenciesTree/SalesAgenciesTree';
import { loadSalesAgencies } from "../../api/agencies";
import cn from './SalesAgenciesViewer.module.scss';

export class SalesAgenciesViewer extends React.PureComponent {
  state = {
    isLoading: true,
    activeTab: 'approved-agencies-tab',
    approvedTree: {},
    pendingList: [],
    rejectedList: [],
  };

  async componentDidMount() {
    try {
      const [approvedTree, pendingList, rejectedList] = await Promise.all([
        loadSalesAgencies({ approvalStatus: 'approved' }),
        loadSalesAgencies({ approvalStatus: 'pending' }),
        loadSalesAgencies({ approvalStatus: 'rejected' }),
      ]);
      this.setState({
        approvedTree,
        pendingList,
        rejectedList,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isLoading: false })
    }
  }

  handleTabChange = (event, activeTab) => {
    this.setState({ activeTab });
  };

  render() {
    const { isLoading, activeTab, approvedTree, pendingList, rejectedList } = this.state;
    return (
      <div>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Approved" value="approved-agencies-tab" />
          <Tab label="Pending" value="pending-agencies-tab" />
          <Tab label="Rejected" value="rejected-agencies-tab"/>
        </Tabs>
        <div className={cn.tabContent}>
          {isLoading ? (
            <div className={cn.loader}>
              <CircularProgress />
            </div>
          ) : (
            <div>
              {activeTab === "approved-agencies-tab" && (
                <SalesAgenciesTree
                  agencyTree={approvedTree}
                />
              )}
              {activeTab === "pending-agencies-tab" && (
                <SalesAgenciesList
                  data={pendingList}
                />
              )}
              {activeTab === "rejected-agencies-tab" && (
                <SalesAgenciesList
                  data={rejectedList}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
